import React, { useContext } from 'react';
import Context from "../context/context";

function TotalResults(){

    const {filteredItems} = useContext(Context);


    let total_items = filteredItems.length;

    let total_text = "You have " + total_items + " results to view.";

    if (total_items === 1){
      total_text = "You have " + total_items + " result to view.";
    }

    if (total_items === 0){
      return false;
    } else {
      return (
          <div className="total-results">
            {total_text}
          </div>
      )
    }

}

export default TotalResults;
